import { Heading } from '@purpur/library';
import { IconInfoFilled } from '@purpur/library/icon/info-filled';
import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { Tooltip } from '@telialt/common-tooltip/src';

export const InsuranceWrapper = styled.div`
    background-color: ${getPurpurColor('gray50')};
    border: 1px solid ${getPurpurColor('gray100')};
    border-radius: 0.5rem;
    padding: ${getPurpurSpacing('300')};
    margin: ${getPurpurSpacing('200')} 0 ${getPurpurSpacing('600')};
    word-break: break-word;
`;

export const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${getPurpurSpacing('300')};
`;

export const InsuranceTitle = styled(Heading)`
    font-size: 1.25rem;
    margin-bottom: 0;
`;

export const InsuranceCheckboxContainer = styled.div`
    flex-direction: column;
    display: flex;
    align-items: start;

    ${purpurMedia('md')`
        justify-content: space-between;
        flex-direction: row;
        gap: ${getPurpurSpacing('300')};
    `};
`;

export const InsuranceTooltipWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-left: 0.375rem;
`;

export const InsuranceTooltipPointer = styled(Tooltip)`
    font-size: 1rem;
    cursor: pointer;
    margin-left: ${getPurpurSpacing('25')};

    &:hover {
        color: ${getPurpurColor('purple500')};
    }
`;

export const PriceContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${purpurMedia('md')`
        padding-top: 0.55rem;
        width: auto;
    `};
`;

export const InsurancePriceLabelContainer = styled.div`
    align-items: center;
    display: flex;
    white-space: nowrap;
    justify-content: end;
`;

export const InsuranceSubtext = styled.div`
    text-align: right;
    flex-basis: 100%;
    font-size: 0.75rem;
    color: rgba(0, 0, 0, 0.6);
    white-space: nowrap;
`;

export const InsuranceDetailsBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    margin-top: ${getPurpurSpacing('300')};
`;

export const InsuranceDetailsExplanation = styled.span`
    color: ${getPurpurColor('gray700')};
`;

export const BlueInfoIcon = styled(IconInfoFilled)`
    color: ${getPurpurColor('blue600')};
`;
